import React from "react";
// Adjust this import path if your folders are arranged differently!
import TutorSessionLogModal from "../tutor/session_logs/TutorSessionLogModal";

export default function SessionLogDetailPage() {
  return <TutorSessionLogModal isReadOnly={true} />;
}
